// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__24msE","content":"Consent_content___qZAb","footer":"Consent_footer__1WXEU"};